import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function HoverCardRenderer({ element }: RendererProps) {
  const { resolveSymbol } = useRenderContext()

  const children = element.children ?? []
  const trigger = children[0]
  const content = children[1]

  return (
    <div
      className={cn("relative group inline-block", element.className)}
      data-testid={`hover-card-${element.id}`}
    >
      {trigger && <ElementRenderer element={trigger} />}
      {content && (
        <div className="absolute left-0 top-full mt-2 z-50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pointer-events-none group-hover:pointer-events-auto">
          <ElementRenderer element={content} />
        </div>
      )}
    </div>
  )
}
